export const GA_MEASUREMENT_ID = "G-MQ87PEZ84V";

export function fireGtagEvent(eventName: string, dedupeKey?: string) {
  if (typeof window === "undefined") return;
  try {
    const k = `gtag_${eventName}_${dedupeKey || "1"}`;
    if (sessionStorage.getItem(k)) return;
    sessionStorage.setItem(k, "1");
  } catch {
    /* private mode */
  }
  const gtag = (window as Window & { gtag?: (...args: unknown[]) => void }).gtag;
  if (typeof gtag === "function") gtag("event", eventName);
}
